import PropTypes from 'prop-types';
import {
  Button, DateTimeFormat, JSONViewer, Modal
} from '@febos-io/design';
import { useCallback, useState } from 'react';
import { useGetObjRecords, useTranslation } from '../../hooks';

export function RecordsTableRow({ mensaje, ingestionTime, }) {
  const { t, } = useTranslation();
  const [configModal, setConfigModal] = useState({
    open: false,
    data: [],
    title: '',
  });
  const { loading: isLoadingData, data: objData, callback: getOjectCallback, } = useGetObjRecords();

  const handleMessageClick = useCallback(() => {
    setConfigModal({
      open: true,
      data: typeof mensaje === 'string' ? mensaje : mensaje.mensaje,
      title: t('Full Message'),
    });
  }, [mensaje, t]);
  const handleStackTraceClick = useCallback(() => {
    setConfigModal({
      open: true,
      data: mensaje.stacktrace,
      title: 'StackTrace',
    });
  }, [mensaje.stacktrace]);
  const handleObjectClick = useCallback(async () => {
    let state = {
      open: true,
      data: objData,
      title: t('Attachment Object'),
    };
    setConfigModal(state);
    state.data = await getOjectCallback(mensaje.objeto);
    setConfigModal(state);
  }, [getOjectCallback, mensaje.objeto, objData, t]);

  const handleAttachmentClick = useCallback(
    async (path) => {
      let state = {
        open: true,
        data: objData,
        title: t('Attachment Object'),
      };
      setConfigModal(state);
      state.data = await getOjectCallback(path);
      setConfigModal(state);
    },
    [getOjectCallback, objData, t]
  );
  return (
    <>
      <tr className="fw-bold">
        <td className="text-center p-0">
          <DateTimeFormat value={ingestionTime} format="dd-MM-yyyy HH:mm:ss" />
        </td>
        <td className="text-center p-0">{t(mensaje.tipo ? mensaje.tipo : 'DEBUG')}</td>
        <td className="text-center p-0">
          {/* {mensaje.function ? mensaje.function : mensaje.includes('END') && 'py_s360'} */}
        </td>
        <td className="text-center p-0">{mensaje.version}</td>
        <td className="text-center p-0">
          {typeof mensaje === 'string' ? mensaje : mensaje.mensaje || mensaje.message}
        </td>
        <td className="text-center p-0 text-nowrap">
          <Button
            className="p-0 ms-1"
            icon="eye"
            iconProps={{ size: '2x', }}
            title={t('See full message')}
            outline
            theme={typeof mensaje === 'string' ? 'secondary' : 'info'}
            onClick={handleMessageClick}
            disabled={typeof mensaje === 'string'}
          />
          <Button
            className="p-0 m-1"
            icon="bug"
            iconProps={{ size: '2x', }}
            title={t('Browse StackTrace')}
            outline
            theme={typeof mensaje === 'string' ? 'secondary' : 'primary'}
            onClick={handleStackTraceClick}
            disabled={typeof mensaje === 'string'}
          />
          {
            //   attachments
            mensaje.objeto && (
              <Button
                className="p-0 me-1"
                icon="puzzle-piece"
                iconProps={{ size: '2x', }}
                title={t('See Related Object')}
                outline
                theme={typeof mensaje === 'string' || !mensaje.objeto ? 'secondary' : 'success'}
                onClick={handleObjectClick}
                disabled={typeof mensaje === 'string' || !mensaje.objeto}
              />
            )
          }
          {
            //   attachments
            mensaje.attachments && typeof mensaje.attachments === 'string' ? (
              <Button
                key={mensaje.attachments}
                className="p-0 me-1"
                icon="puzzle-piece"
                iconProps={{ size: '2x', }}
                title={t('See Related Object')}
                outline
                theme="success"
                onClick={() => handleAttachmentClick(mensaje.attachments)}
              />
            ) : (
              mensaje.attachments?.map((attachment) => (
                <Button
                  key={attachment}
                  className="p-0 me-1"
                  icon="puzzle-piece"
                  iconProps={{ size: '2x', }}
                  title={t('See Related Object')}
                  outline
                  theme="success"
                  onClick={() => handleAttachmentClick(attachment)}
                />
              ))
            )
          }
        </td>
      </tr>
      <Modal
        changeState={() => setConfigModal({
          ...configModal.data,
          open: !configModal.open,
        })
        }
        show={configModal.open}
        title={(
          <>
            {configModal.title}
            {configModal.title === t('Attachment Object') && (
              <Button
                className="p-0 ms-2"
                icon="copy"
                iconProps={{ size: '2x', }}
                title={t('Copy Object')}
                outline
                theme="secondary"
                onClick={() => {
                  navigator.clipboard.writeText(JSON.stringify(configModal.data, null, 2));
                }}
              />
            )}
          </>
        )}
        size="lg"
      >
        {isLoadingData ? `${t('Loading')}...` : <JSONViewer json={configModal.data} />}
      </Modal>
    </>
  );
}

RecordsTableRow.propTypes = {
  mensaje: PropTypes.object.isRequired,
  ingestionTime: PropTypes.any.isRequired,
};
export default RecordsTableRow;
